import { ChatFeedbackRequest, FetchChatsRequest, GetAllTicketsRequest, TraceFlowkRequest } from "../../interfaces/serviceInterfaces";
import axiosInstanceMain from "../axiosInstance";
import { ROLES } from "../../constants/appConstants";
import { isSupportAnalystRole } from "../transitionManagerServices";
import { getEnv } from "../../utils/envConfig";

//const axiosInstance = axiosInstanceMock;
const axiosInstance = axiosInstanceMain;
const BASE_URL = getEnv('VITE_API_BASE_URL_END_USER');
// const IT_MANAGER_BASE_URL = getEnv('VITE_API_BASE_URL_IT_MANAGER')
const IT_MANAGER_BASE_URL = getEnv('VITE_API_BASE_URL_IT_MANAGER');
const END_USER_CHAT_FEEDBACK = '/endUser/feedback';

export async function getAllTickets({
    pageSize,
    pageNo,
    appliedFilters = {},
    currentRole
}: GetAllTicketsRequest) {
    try {
        const isSupportAnalyst = currentRole === ROLES.SUPPORT_ANALYST;
        const filters = appliedFilters?.filters || {};
        const response = await axiosInstance.request({
            baseURL: BASE_URL,
            method: 'GET',
            url: `/endUser/getAllTickets`,
            params: {
                pageSize,
                pageNo,
                ...(appliedFilters?.search_text && { search_text: appliedFilters.search_text }),
                ...(appliedFilters?.search_column && { search_column: appliedFilters.search_column }),
                ...(filters.status && { status: filters.status }),
                ...(filters.priority && { priority: filters.priority }),
                ...(appliedFilters?.start_date && { start_date: appliedFilters.start_date }),
                ...(appliedFilters?.end_date && { end_date: appliedFilters.end_date }),
            },
        });
        return response.data;
    } catch (error) {
        console.log(error);
    }
}

export async function checkTicketStatus({
    ticket_id
}: any) {
    try {
        const response = await axiosInstance.request({
            baseURL: BASE_URL,
            method: 'GET',
            url: `/endUser/checkTicketStatus/${ticket_id}`,
        })
        return response.data;
    } catch (error) {
        console.log(error);
    }
}

export async function fetchChats({
    user_id,
    pageSize,
    pageNo,
    appliedFilters,
    currentRole
}: FetchChatsRequest) {
    const isSupportAnalyst = currentRole === ROLES.SUPPORT_ANALYST;
    try {
        const params: Record<string, any> = {
            pageSize,
            pageNo,
        };

        if (appliedFilters?.search_text) {
            params.search_text = appliedFilters.search_text;
        }

        if (appliedFilters?.search_column) {
            params.search_column = appliedFilters.search_column;
        }

        return axiosInstance.request({
            baseURL: BASE_URL,
            method: 'GET',
            url: `/endUser/fetchChats`,
            params,
        });
    } catch (error) {
        console.error(error);
    }
}

export async function fetchChatHistory({
    thread_id,
    currentRole
}: any) {
    const isSupportAnalyst = currentRole === ROLES.SUPPORT_ANALYST;
    try {
        return axiosInstance.request({
            baseURL: BASE_URL,
            method: 'GET',
            url: `/endUser/fetchChatHistory/${thread_id}`,
        })
    } catch (error) {
        console.log(error);
    }
}

export async function connectAgent({
    user_id,
    prompt
}: any) {
    try {
        const response = await axiosInstance.request({
            baseURL: BASE_URL,
            method: 'POST',
            url: `/endUser/connectAgent`,
            data: {
                user_id: user_id,
                prompt: prompt,
            },
        });
        return response.data;
    } catch (error) {
        console.log(error);
        throw error;
    }
}

export async function notifications({
    user_id,
    pageSize,
    pageNo,
    currentRole
}: any) {
    const isSupportAnalyst = currentRole === ROLES.SUPPORT_ANALYST;
    try {
        const response = await axiosInstance.request({
            baseURL: BASE_URL,
            method: 'GET',
            url: `/endUser/notifications`,
        })
        return response.data;
    } catch (error) {
        console.log(error);
    }
}

export async function sendChatFeedback({
    chatId,
    messageId,
    userId,
    like,
    dislike,
    comment,
    traceId
}: ChatFeedbackRequest) {
    try {
        return axiosInstance.request({
            baseURL: BASE_URL,
            method: 'POST',
            url: `${END_USER_CHAT_FEEDBACK}`,
            data: {
                chat_id: chatId,
                message_id: messageId,
                user_id: userId,
                like,
                dislike,
                feedbackComments: comment,
                trace_id: traceId
            }
        })
    } catch (error) {
        console.log(error);
    }
}

export async function getChatFeedback({
    chatId
}: ChatFeedbackRequest) {
    try {
        return axiosInstance.request({
            baseURL: BASE_URL,
            method: 'GET',
            url: `${END_USER_CHAT_FEEDBACK}/${chatId}`
        })
    } catch (error) {
        console.log(error);
    }
}

export async function acknowledgeNotification(
    notification_id
        : any) {
    try {
        const response = await axiosInstance.request({
            baseURL: BASE_URL,
            method: 'PUT',
            url: `/endUser/notifications/${notification_id}`,
            data: {
                status: 'Acknowledged'
            },
        })
        return response.data;
    } catch (error) {
        console.log(error);
    }
}

export async function traceFlow({
    traceId
}: TraceFlowkRequest) {
    try {
        return axiosInstance.request({
            baseURL: BASE_URL,
            method: 'GET',
            url: `/endUser/traceFlow/${traceId}`
        })
    } catch (error) {
        console.log(error);
    }
}
